/**
 * An enum to specify the type of block being deserialized
 */
export enum BlockType{
    CLB, // console log block
    CONST,
    EQ,
    GEQ,
    GT,
    LEQ,
    LT,
    AND,
    NOT,
    OR,
    DIV,
    SUM,
    SUBTRACT,
    EXP,
    MOD,
    PROD,
    MAKE_SHAPE,
    MOVE_SHAPE,
    ROTATE_SHAPE,
    SCALE_SHAPE,
    GET_SHAPE,
    FOR,
    IF,
    WHILE,
    TERNARY,
    VAR_ASSIGN,
    VAR_DELETE,
    VAR_RETRIEVE,
    NEST,
    JOY_X,
    JOY_Y,
    BTN_STATUS,
    ARR_CREATE,
    ARR_SET_IX,
    ARR_GET_IX,
    MAKE_CONTROL_ELEM,
    GET_X,
    GET_Y,
}